var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      staticClass: "rb-response-drawer",
      class: { "is-fullscreen": _vm.isFullscreen },
      attrs: {
        visible: _vm.showResponseDrawer,
        size: _vm.isFullscreen ? "100%" : "45vw",
        modal: false,
        "with-header": false,
        "wrapper-closable": false,
        "destroy-on-close": "",
        "close-on-press-escape": "",
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column", staticStyle: { height: "100vh" } },
        [
          _c(
            "response-drawer-toolbar",
            {
              attrs: {
                "is-review": _vm.isReview,
                "is-loading": _vm.isLoading,
                "is-fullscreen": _vm.isFullscreen,
                "show-response-drawer": _vm.showResponseDrawer,
              },
              on: {
                fullscreen: function ($event) {
                  return _vm.onOpenFullscreen(!_vm.isFullscreen)
                },
                prev: _vm.onPrevRow,
                next: _vm.onNextRow,
                close: _vm.onResponseDrawerClosed,
              },
            },
            [
              _vm.responseData && _vm.responseData.url
                ? _c(
                    "a",
                    {
                      staticClass:
                        "el-button el-button--default el-button--mini is-plain ml-3",
                      attrs: {
                        slot: "left-actions",
                        href: _vm.responseData.url,
                        target: "_blank",
                      },
                      slot: "left-actions",
                    },
                    [
                      _vm._v(
                        " Go to " + _vm._s(_vm.reviewQuestionTextLabel()) + " "
                      ),
                      _c("external-link-icon", {
                        staticClass: "rb-icon-xs",
                        attrs: { title: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm.isLoading
            ? _c("div", { staticClass: "container-fluid flex-grow-1" }, [
                _c("div", { staticClass: "row h-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-8 body-content d-flex align-items-center justify-content-center h-100 py-3",
                    },
                    [_c("loading-panel")],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-4 response-side-panel py-3 bg-gray-light",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "product-information d-flex align-items-center pb-3 border-bottom mb-2",
                        },
                        [
                          _c("div", {
                            staticClass: "skeleton mr-3",
                            staticStyle: { width: "50px", height: "50px" },
                          }),
                          _c("div", {
                            staticClass: "skeleton skeleton-text w-50",
                            staticStyle: { height: "1rem" },
                          }),
                        ]
                      ),
                      _vm._l([1, 2, 3, 4, 5, 6], function (item, idx) {
                        return _c(
                          "div",
                          {
                            key: `panel-skeleton--${idx}`,
                            staticClass: "d-flex flex-column mb-3",
                          },
                          [
                            _c("div", {
                              staticClass: "skeleton skeleton-text mb-2 w-50",
                            }),
                            _c("div", {
                              staticClass: "skeleton skeleton-text",
                              staticStyle: { height: "1.5rem" },
                            }),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "response-drawer-footer bg-white" },
                    [
                      _c("div", {
                        staticClass: "skeleton skeleton-text",
                        staticStyle: { height: "2rem", "border-radius": "5px" },
                      }),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.isLoadingFailed
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c(
                    "el-alert",
                    {
                      staticClass: "mt-3",
                      attrs: {
                        title: `Could not get ${_vm.reviewQuestionTextLabel()} data`,
                        closable: false,
                        "show-icon": "",
                      },
                    },
                    [_vm._v(" Please try again in a moment. ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isLoading && !_vm.isLoadingFailed
            ? _c(
                "div",
                {
                  staticClass:
                    "response-drawer-body container-fluid flex-grow-1",
                },
                [
                  _c("div", { staticClass: "row h-100" }, [
                    _c("div", { staticClass: "col-8 body-content py-3" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "review-container rb-response-management-content",
                        },
                        [
                          _c("div", { staticClass: "review-wrapper mb-3" }, [
                            _vm.data && _vm.data.title
                              ? _c(
                                  "h5",
                                  { staticClass: "review-title mb-1" },
                                  [
                                    _c("truncate-text", {
                                      attrs: {
                                        text: _vm.data.title,
                                        limit: 100,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "review-subtitle-wrapper mb-2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "review-subtitle text-muted d-flex align-items-center flex-wrap",
                                  },
                                  [
                                    _vm.data && _vm.data.author
                                      ? _c(
                                          "span",
                                          { staticClass: "review-author" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.data.author) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.formattedReviewDate
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _vm.data && _vm.data.author
                                              ? _c("span", {
                                                  staticClass:
                                                    "text-divider mx-2",
                                                })
                                              : _vm._e(),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formattedReviewDate
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.numberStars
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "text-divider mx-2",
                                            }),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: `Review rating of ${_vm.numberStars}`,
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c("review-rating-bar", {
                                                  staticClass:
                                                    "d-inline-flex align-items-center h-100",
                                                  attrs: {
                                                    "number-stars":
                                                      _vm.numberStars,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "review-tags d-flex justify-content-between mb-3",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center flex-wrap",
                                  },
                                  [
                                    _vm.isReview && _vm.isVerified
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "The person writing the review has been verified to have purchased the product from the retailer",
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center mr-2",
                                                attrs: { size: "mini" },
                                              },
                                              [
                                                _vm.isVerified
                                                  ? _c("check-circle-icon", {
                                                      staticClass:
                                                        "mr-1 rb-icon-sm",
                                                    })
                                                  : _vm._e(),
                                                _c("span", [
                                                  _vm._v(" Verified Purchase "),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.data && _vm.data.retailer_source
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: `Source of the ${_vm.reviewQuestionTextLabel()}`,
                                              "open-delay": 500,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center mr-2",
                                                class: {
                                                  "text-capitalize":
                                                    !_vm.data.retailer_source.includes(
                                                      "www."
                                                    ),
                                                },
                                                attrs: { size: "mini" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.data.retailer_source
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.positiveVotes
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              type: "info",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.positiveVotes) +
                                                " positive votes "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("div", [
                              !_vm.isReview && (!_vm.data || !_vm.data.title)
                                ? _c("h6", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.reviewQuestionTextLabel(true)
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.reviewOrQuestion
                                ? _c(
                                    "div",
                                    { staticClass: "response-review-text" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "mb-0 review-text" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.truncateText(
                                                  _vm.reviewOrQuestion
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.showCollapseTextButton
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "text-info",
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: () =>
                                                  (_vm.isCollapseText =
                                                    !_vm.isCollapseText),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.isCollapseText
                                                      ? "Read more"
                                                      : "Collapse text"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "response-timeline mb-3 rb-response-management-response-timeline",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "timeline-header d-flex align-items-center justify-content-between",
                            },
                            [
                              _c(
                                "h6",
                                [
                                  _vm._v(" Responses "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: `Responses can be from the author of the ${_vm.reviewQuestionTextLabel()} or from users who respond on the retailer's website.`,
                                        "open-delay": 500,
                                      },
                                    },
                                    [
                                      _c("info-icon", {
                                        staticClass:
                                          "text-muted cursor-pointer rb-icon-sm",
                                        attrs: { title: "" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          [
                            _vm.responseData && _vm.data && _vm.data.source
                              ? _c(
                                  "div",
                                  [
                                    _c("updates-timeline", {
                                      attrs: {
                                        updates: _vm.responseUpdates,
                                        source: _vm.data.source,
                                        "input-id": _vm.data.id,
                                        "is-review": _vm.isReview,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-4 response-side-panel py-3 bg-gray-light rb-response-management-input-values",
                      },
                      [
                        _vm.product
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "product-information d-flex flex-wrap align-items-center pb-3 border-bottom mb-2",
                              },
                              [
                                _vm.product.imgurl
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product-image mb-2 text-center",
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid",
                                          staticStyle: { "max-height": "60px" },
                                          attrs: {
                                            src: _vm.product.imgurl,
                                            alt: "Product Image",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.product.imgurl
                                  ? [
                                      _vm.responseData.name &&
                                      _vm.reviewData.product_url
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "product-title small",
                                              attrs: {
                                                href: _vm.reviewData
                                                  .product_url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.responseData.name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm.responseData.name &&
                                          _vm.product.url
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "product-title small",
                                              attrs: {
                                                href: _vm.product.url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.responseData.name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : [
                                      _vm.responseData.name &&
                                      _vm.reviewData.product_url
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: "Go to product",
                                                "open-delay": 500,
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.reviewData
                                                      .product_url,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.responseData.name
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("external-link-icon", {
                                                    staticClass: "rb-icon-xs",
                                                    attrs: { title: "" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm.responseData.name &&
                                          _vm.product.url
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: "Go to product",
                                                "open-delay": 500,
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "el-button el-button--default el-button--mini is-plain rb-product-button",
                                                  attrs: {
                                                    href: _vm.product.url,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.responseData.name
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("external-link-icon", {
                                                    staticClass: "rb-icon-xs",
                                                    attrs: { title: "" },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }